import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  USER_ID,
  USER_EMAIL,
  USER_EXPIRATION,
  EMPLOYEE_ID,
  MATRIX_ID,
  COMPANY_IDS,
  MODULE,
  USER_NAME,
  UG_HASH,
  IS_MASTER_PASSWORD_AUTHENTICATION,
} from './constants';

const getUserFromLocalStorage = () => ({
  accessToken: localStorage.getItem(ACCESS_TOKEN),
  refreshToken: localStorage.getItem(REFRESH_TOKEN),
  userId: localStorage.getItem(USER_ID),
  userEmail: localStorage.getItem(USER_EMAIL),
  userName: localStorage.getItem(USER_NAME),
  userExpiration: localStorage.getItem(USER_EXPIRATION),
  employeeId: localStorage.getItem(EMPLOYEE_ID),
  matrixId: localStorage.getItem(MATRIX_ID),
  companyIds: localStorage.getItem(COMPANY_IDS),
  module: localStorage.getItem(MODULE),
  ugHash: localStorage.getItem(UG_HASH),
  isMasterPasswordAuthentication: localStorage.getItem(
    IS_MASTER_PASSWORD_AUTHENTICATION,
  ),
});

export default getUserFromLocalStorage;
